import { Controller } from "@hotwired/stimulus"

// Two-pane video type picker.
//
// The left pane holds one radio per generation type; the right pane holds one
// panel per type, all rendered server-side. Exactly one panel is visible at a
// time — selecting a type hides the rest, so you can never end up with several
// stacked forms (and never one hidden below the fold).
//
//   <div data-controller="video-type-picker">
//     <input type="radio" name="type" value="tax_breakdown"
//            data-action="change->video-type-picker#select">
//     <div data-video-type-picker-target="panel" data-type-id="tax_breakdown">…</div>
//   </div>
export default class extends Controller {
  static targets = ["panel", "option", "empty"]

  connect() {
    const checked = this.element.querySelector('input[type="radio"]:checked')
    this.show(checked ? checked.value : null)
  }

  select(event) {
    this.show(event.target.value)
  }

  show(typeId) {
    this.panelTargets.forEach((panel) => {
      panel.classList.toggle("hidden", panel.dataset.typeId !== typeId)
    })

    this.optionTargets.forEach((option) => {
      const active = option.dataset.typeId === typeId
      option.classList.toggle("bg-indigo-50", active)
      option.classList.toggle("text-indigo-700", active)
      option.classList.toggle("font-medium", active)
    })

    if (this.hasEmptyTarget) {
      this.emptyTarget.classList.toggle("hidden", Boolean(typeId))
    }
  }
}
